<template>
  <div class="ELYXModalButton" @click="emitClick">
    <slot></slot>
  </div>
</template>

<script>
export default {
  methods: {
    emitClick() {
      this.$emit("click");
    },
  },
};
</script>

<style>
.ELYXModalButton {
  font-size: 16px;
  letter-spacing: 0.5px;
  font-weight: 400;
  border-radius: 360px;
  cursor: pointer;
  transition: 0.1s ease;
  text-align: center;
  outline: none;
  border-color: unset;
  border: none;
  box-sizing: border-box;
  min-width: 85px;
  margin: 0 auto;
  font-family: "Nunito", sans-serif;
  background-color: #111;
  color: white;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: rgb(15 15 15 / 5%) 0px 0px 0px 1px, rgb(15 15 15 / 10%) 0px 3px 6px, rgb(82 82 82 / 20%) 0px 9px 24px;
  margin-top: 15px;
  width: 80%;
  flex-shrink: 0;
}
.ELYXModalButton:hover {
  background-color: #454545;
}
</style>
